import {_User as User} from "./_User";

export const WalletsAPI = {
    User: User
};